import { render, staticRenderFns } from "./ModalTextError.vue?vue&type=template&id=9a99bd34&scoped=true&"
import script from "./ModalTextError.vue?vue&type=script&lang=js&"
export * from "./ModalTextError.vue?vue&type=script&lang=js&"
import style0 from "./ModalTextError.vue?vue&type=style&index=0&id=9a99bd34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a99bd34",
  null
  
)

export default component.exports